import React, { useContext } from 'react';
import { IBreadcrumb } from '../../interfaces';
import { MarketContext } from '../../context/markets';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { NavigationPanel, Section } from '../../components/NavigationPanel';

type IProps = {
    breadcrumbs: IBreadcrumb[];
    navigationItems: Section[];
    sections: React.ReactNode;
    offerUrl: string;
};

export const CompanyDesktopDetails = (props: IProps) => {
    const { breadcrumbs, navigationItems, sections, offerUrl } = props;
    const { markets } = useContext(MarketContext);
    const { isCruise1st } = markets;

    let desktopSectionsPosition = [
        'zoneRecommendation',
        'gallery',
        'form',
        'advisor',
        'ships',
        'seo',
        'reviews',
    ];

    if (isCruise1st) {
        desktopSectionsPosition = [
            'zoneRecommendation',
            'gallery',
            'ships',
            'seo',
            'advisor',
            'reviews',
            'form',
        ];
    }
    return (
        <>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <NavigationPanel sections={navigationItems} offerUrl={offerUrl} />
            {desktopSectionsPosition.map((item) => sections[item]?.())}
        </>
    );
};
